import { Target, CornerDownRight, Crosshair, TrendingUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { LiveInsight, StatFamily } from '@/hooks/useLiveInsights';

const STAT_ICONS: Record<StatFamily, React.ReactNode> = {
  sot: <Target className="h-4 w-4" />,
  corners: <CornerDownRight className="h-4 w-4" />,
  shots: <Crosshair className="h-4 w-4" />,
};

interface LiveInsightCardProps {
  insight: LiveInsight;
}

export function LiveInsightCard({ insight }: LiveInsightCardProps) {
  const isStrong = insight.level === 'strong';
  const hasRatio = insight.level !== 'informational';

  return (
    <div
      className={cn(
        'rounded-lg border p-3 transition-all text-sm',
        isStrong
          ? 'border-[hsl(var(--sg7-gold)/0.5)] bg-[hsl(var(--sg7-gold)/0.06)]'
          : 'border-[hsl(var(--card-border))] bg-[hsl(var(--card))]'
      )}
    >
      {/* Header: icon + team + count */}
      <div className="flex items-center gap-2 font-semibold text-foreground">
        <span className={cn(
          'flex-shrink-0',
          isStrong ? 'text-[hsl(var(--sg7-gold))]' : 'text-muted-foreground'
        )}>
          {STAT_ICONS[insight.statFamily]}
        </span>
        <span className="truncate">{insight.message}</span>
      </div>

      {/* Sub-message: historical ratio */}
      {hasRatio && insight.subMessage && (
        <p className="mt-1 text-xs text-muted-foreground pl-6">
          {insight.subMessage}
        </p>
      )}

      {/* Strong emphasis */}
      {isStrong && insight.strongMessage && (
        <div className="mt-1.5 flex items-center gap-1.5 pl-6 text-xs font-medium text-[hsl(var(--sg7-gold))]">
          <TrendingUp className="h-3.5 w-3.5" />
          <span>{insight.strongMessage}</span>
        </div>
      )}
    </div>
  );
}
